import { ApiError } from '@/lib/api/errors.js';
import { t } from '@/lib/i18n/messages.js';
import { cn } from '@/lib/utils.js';

interface ResultsErrorStateProps {
  error: Error;
}

function getErrorMessage(error: Error): string {
  if (error instanceof ApiError) {
    switch (error.code) {
      case 'SEMI_JOIN_TOO_BROAD':
        return t('report.error_semi_join');
      case 'API_AUTH':
      case 'API_ERROR':
        return t('report.error_erp');
      case 'PERMISSION_DENIED':
      case 'INSUFFICIENT_GRANT_LEVEL':
        return t('report.error_insufficient_grant');
      case 'RATE_LIMIT':
        return t('report.error_rate_limit');
      case 'TIMEOUT':
        return t('report.error_timeout');
      case 'DATA_SCOPE_INVALID':
        return t('report.error_data_scope_invalid');
      case 'TENANT_REPORT_DISABLED':
        return t('report.error_tenant_report_disabled');
      default:
        return t('report.error_generic');
    }
  }
  return t('report.error_generic');
}

export function ResultsErrorState({ error }: ResultsErrorStateProps) {
  const message = getErrorMessage(error);
  const requestId = error instanceof ApiError ? error.requestId : undefined;

  return (
    <div
      role="alert"
      className={cn('flex flex-col items-center justify-center gap-3 py-16 text-center')}
    >
      <svg
        className="h-12 w-12 text-[var(--color-qup-error)]"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.5"
        aria-hidden="true"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M12 9v3.75m-9.303 3.376c-.866 1.5.217 3.374 1.948 3.374h14.71c1.73 0 2.813-1.874 1.948-3.374L13.949 3.378c-.866-1.5-3.032-1.5-3.898 0L2.697 16.126zM12 15.75h.007v.008H12v-.008z"
        />
      </svg>
      <p className="text-sm font-medium text-[var(--color-qup-text-dark)]">{message}</p>
      {requestId !== undefined && (
        <p className="text-xs text-[var(--color-qup-text-muted-dark)]">
          ID: <code className="font-mono">{requestId}</code>
        </p>
      )}
    </div>
  );
}
